import paper from '../../assets/images/home/page-customer/svg/pages.svg'
import commonDemo from '../../assets/images/home/page-customer/webp/common-demo.webp'
import customer from '../../assets/images/home/page-customer/webp/customer.webp'
import intellibitPage from '../../assets/images/home/page-customer/webp/intellinit.webp'
import permission from '../../assets/images/home/page-customer/webp/set-up-permission.webp'
import topProduct from '../../assets/images/home/page-customer/webp/top-product.webp'
import people from '../../assets/images/home/people-relationship/svg/people.svg'
import draft from '../../assets/images/home/people-relationship/webp/draft.webp'
import followUpWeek from '../../assets/images/home/people-relationship/webp/follow-up-week.webp'
import followUp from '../../assets/images/home/people-relationship/webp/follow-up.webp'
import intellibit from '../../assets/images/home/people-relationship/webp/intellibit.webp'
import michael from '../../assets/images/home/people-relationship/webp/michael.webp'
import amanda from '../../assets/images/home/pioneers-love/png/amanda.png'
import ashley from '../../assets/images/home/pioneers-love/png/asshley.png'
import jamie from '../../assets/images/home/pioneers-love/png/jamie.png'
import jesse from '../../assets/images/home/pioneers-love/png/jasse.png'
import jeff from '../../assets/images/home/pioneers-love/png/jeff.png'
import john from '../../assets/images/home/pioneers-love/png/john.png'
import sarah from '../../assets/images/home/pioneers-love/png/sarah.png'
import bootstrapped from '../../assets/images/home/pioneers-love/svg/bootstrapped.svg'
import genius from '../../assets/images/home/pioneers-love/svg/genius.svg'
import growth from '../../assets/images/home/pioneers-love/svg/growth.svg'
import melodi from '../../assets/images/home/pioneers-love/svg/melodi.svg'
import prefab from '../../assets/images/home/pioneers-love/svg/prefab.svg'
import sundays from '../../assets/images/home/pioneers-love/svg/sunday.svg'
// CUSTOMER RELATIONSHIP PEOPLE
import pipeline from '../../assets/images/home/pipelines/svg/pipeline.svg'
// PIPELINE AUTOMATICALLY
import experience from '../../assets/images/home/pipelines/webp/action-task.webp'
import strategize from '../../assets/images/home/pipelines/webp/everyone.webp'
import forecast from '../../assets/images/home/pipelines/webp/forecast.webp'
import businessdeal from '../../assets/images/home/pipelines/webp/your-pipeline.webp'
// PAGES CUSTOMER RELATIONSHIP

import {
  GMail,
  GoogleMeet,
  Layers,
  LinkedIn,
  Lock,
  MicrosoftTeam,
  SOS,
  Slack,
  Twitter,
  Youtube,
  ZoomMeeting,
} from './Icons'

export const pioneersLoveAi = [
  {
    paragraph:
      "“I start and end every day with Day.ai – it's how I prep for every meeting and I save an hour in the evening on follow-ups. Our team loves it too, its a key part of how we maintain client relationships”",
    image: ashley,
    userName: 'Ashley Chang',
    profession: 'Founder and CEO, Sundays',
    companyIcon: sundays,
    iconSize: 'lg:w-auto',
  },
  {
    paragraph:
      '“The ground truth of my customers lives in Day.ai.  Having an automatic way to stay connected to customer reality has been huge as we’ve grown our business.”',
    image: jeff,
    userName: 'Jeff Dwyer',
    profession: 'Founder and CEO, Prefab',
    companyIcon: prefab,
    iconSize: 'lg:w-auto',
  },
  {
    paragraph:
      '“I can’t imagine building a company without it.  Day.ai supercharges my productivity 10x so I can make the most of every interaction with prospects and customers.”',
    image: sarah,
    userName: 'Sara Remsen',
    profession: 'Founder and CEO, Melodi',
    companyIcon: melodi,
    iconSize: 'lg:w-auto',
  },
  {
    paragraph:
      "“I’ve been a revenue leader for 20 years, and when I saw Day.ai for the first time, I was all-in immediately.  Why fuss with an AI Meeting assistant and old school CRM when Day.ai just works? First time in my career I've seen 100% adherence to data input (most is automated)”",
    image: jamie,
    userName: 'Jamie Farrell',
    profession: 'Co-founder, Stealth. 5 exits',
    companyIcon: '',
    iconSize: 'lg:w-auto',
  },
  {
    paragraph:
      '“Our sales and account management teams use Day.ai to smoothen customer handoffs, and to have one place to go to know everything about a customer relationship.  The impact on customer experience is huge.”',
    image: john,
    userName: 'John Sherer',
    profession: 'COO, Growth Assistant',
    companyIcon: growth,
    iconSize: 'lg:w-auto',
  },
  {
    paragraph:
      '“This is SOOO amazing, WOW.  When I got my first post-meeting email from Day.ai, I immediately made it the standard across my companies.”',
    image: jesse,
    userName: 'Jesse Pujji',
    profession: 'Founder and CEO, Bootstrapped Giants',
    companyIcon: bootstrapped,
    iconSize: 'lg:w-auto sm:w-[83px] w-[180px]',
  },
  {
    paragraph:
      '“Day.ai is different. We synced our Google accounts and got value immediately. My time is now freed up to be a partner to my clients rather than a task-master or to-do list generator.”',
    image: amanda,
    userName: 'Amanda Smith',
    profession: 'Podcast Strategy Lead + Producer, Share Your Genius',
    companyIcon: genius,
    iconSize: 'lg:w-auto',
  },
]

export const socialAppsWorks = [
  {
    icon: <GMail />,
  },
  {
    icon: <MicrosoftTeam />,
  },
  {
    icon: <GoogleMeet />,
  },
  {
    icon: <ZoomMeeting />,
  },
  {
    icon: <Slack />,
  },
]

// collaborate
export const collaborateList = [
  {
    icon: (
      <Layers className="mx-auto h-20 w-20 transition-all duration-300 group-hover:opacity-80" />
    ),
    title: 'Workspaces',
    Info: 'Unlimited private team environments',
  },
  {
    icon: (
      <Lock className="mx-auto h-20 w-20 transition-all duration-300 group-hover:opacity-80" />
    ),
    title: 'Permissions',
    Info: 'RBAC-powered field-level permissions',
  },
  {
    icon: (
      <SOS className="mx-auto h-20 w-20 transition-all duration-300 group-hover:opacity-80" />
    ),
    title: 'SOC 2',
    Info: 'SOC 2 Type 1 in progress',
  },
]

// Customer resationship
export const customerRelationships = [
  {
    icon: people,
    heading: 'People',
    subheading: 'Relationship-focused Meeting Assistant',
    cards: [
      {
        heading: 'Be more present in meetings',
        description:
          'Never take notes on a video call again. Automatically receive human-quality meeting notes after your meetings. ',
        image: intellibit,
        imageStyle: 'rotate-[-5deg] left-16',
      },
      {
        heading: 'Perfect relationship recall',
        description:
          'Be at ease. Day.ai remembers everything about the people you meet and email. Search to find any detail.',
        image: michael,
        imageStyle: 'rotate-[-5deg] left-16',
      },
      {
        heading: 'Follow-ups, finished',
        description:
          'Just press send on an auto-generated follow up email with meeting highlights and action items written in a human tone.',
        image: draft,
        imageStyle: 'rotate-[-5deg] left-16',
      },
      {
        heading: 'All of your relationships, in one place',
        description:
          'Share contacts and relationship history across your team.',
        image: followUp,
        imageStyle: '!top-[190px] rotate-[-5deg] left-16',
      },
      {
        heading: 'Follow up reminders',
        description:
          'Nothing slips through the cracks. Day.ai will remind you to follow up at the right time.',
        image: followUpWeek,
        imageStyle:
          ' !top-[110px] min-w-[542px] h-[482px] left-10 rotate-[-5deg] left-16  group-hover:left-0',
      },
    ],
  },
  {
    icon: pipeline,
    heading: 'Pipelines',
    subheading: 'Automatically-organized CRM',
    cards: [
      {
        heading: 'Your pipeline, updated',
        description:
          'Just had a great meeting? The deal is created automatically and sits in the right stage.',
        image: businessdeal,
        imageStyle:
          'min-w-[600px] h-[560px] left-1/2 -translate-x-1/2 group-hover:left-1/2 !top-20 rotate-[-10deg] group-hover:!left-1/2',
      },
      {
        heading: 'Keep everyone aligned',
        description:
          'Share your pipeline update async. Use meeting time to strategize.',
        image: strategize,
        imageStyle: 'min-w-[449px] h-[517px] left-20',
      },
      {
        heading: 'Deliver a great experience',
        description:
          'No need to manually update, once tasks are completed, the deal moves itself.',
        image: experience,
        imageStyle:
          'left-1/2 -translate-x-1/2 group-hover:left-1/2 group-hover:-translate-y-3 group-hover:!left-1/2',
      },
      {
        heading: 'Your forecast on demand',
        description: 'Automatic forecast generation keeps everyone up to date.',
        image: forecast,
        imageStyle: '!top-[190px] min-w-[450px] h-[370px] left-20',
      },
    ],
  },
  {
    icon: paper,
    heading: 'Pages',
    subheading: 'Customer-centric Knowledge Base',
    cards: [
      {
        heading: 'Communicate trends and patterns',
        description:
          'Tell the right story with objective sources from conversations.',
        image: commonDemo,
        imageStyle: 'min-w-[450px] h-[480px] rotate-[5deg] left-20',
      },
      {
        heading: 'Prioritize effectively',
        description:
          'Make fast decisions on what to work on next by listening to customers.',
        image: topProduct,
        imageStyle: 'min-w-[450px] h-[380px] rotate-[5deg] left-20',
      },
      {
        heading: 'Collaborate with prospects and customers',
        description:
          'Stay aligned on next steps, communicate effectively – even when you’re not in the room.',
        image: intellibitPage,
        imageStyle: 'min-w-[460px] h-[380px] rotate-[5deg] left-20',
      },
      {
        heading: 'Organize marketing assets',
        description:
          'Save customer quotes and content ideas to speed up creation.',
        image: customer,
        imageStyle: 'min-w-[460px] h-[432px] rotate-[5deg] left-14',
      },
      {
        heading: 'Create documentation',
        description:
          'Explaining yourself over and over? Let Day.ai turn your repetition into documentation.',
        image: permission,
        imageStyle: 'min-w-[460px] h-[400px] rotate-[5deg] left-14',
      },
    ],
  },
]
// Pricing
export const PricingList = [
  {
    planType: 'Free',
    // Offer: "30-day Free Trial",
    planInfo: 'For everyone in your company',

    specifications: [
      'Join a workspace',
      'View recordings & clips',
      'Search knowledge base',
      'Generate, view, share, and comment on pages',
      'Create, manage, and view Pipelines',
    ],
    price: 0,
  },
  {
    planType: 'Pro',
    Offer: '30-day Free Trial',
    planInfo: 'For Founders, Sales, Customer Success, Research, and Recruiting',

    specifications: [
      'Connect your Google Account',
      'Sync Gmail Contacts & Email',
      'Record meetings on Zoom, Meet, Teams',
      'Meeting prep, notes, action items, and clips',
      'Automatically-organized CRM',
    ],
    price: 50,
  },
]

// footerSocialIcons
export const footerSocialIcons = [
  {
    icon: <Youtube />,
    url: 'http://www.youtube.com/@Day_ai_app',
  },
  {
    icon: <Twitter />,
    url: 'https://twitter.com/Day_ai_app',
  },
  {
    icon: <LinkedIn />,
    url: 'https://www.linkedin.com/company/day-ai',
  },
]
